class OHeader {
	scrollDirection = 'down';

	previousScrollTop = 0;

	scrollStart = 0;

	heightHeader = 0;

	/** @param {HTMLElement} element */
	constructor(element) {
		this.element = element;

		document.addEventListener('scroll', () => {
			const { scrollTop } = document.scrollingElement;

			this.scrollDirection = this.previousScrollTop < scrollTop ? 'down' : 'up';

			this.previousScrollTop = scrollTop;
			if (scrollTop > 0) {
				if (this.scrollDirection === 'up') {
					this.scrollStart = scrollTop;
					element.style.setProperty('--_transition-property', 'translate');
					element.style.removeProperty('--_translateY');
					element.toggleAttribute('data-hidden', false);
				} else {
					const translateY = Math.max(
						Math.min((this.scrollStart - scrollTop) * -0.8, this.heightHeader),
						0,
					);
					element.style.removeProperty('--_transition-property');
					element.style.setProperty('--_translateY', `${translateY * -1}px`);
					element.toggleAttribute('data-hidden', translateY >= this.heightHeader * 0.6);
				}
			} else {
				element.style.removeProperty('--_translateY');
			}
		}, {
			passive: true,
		});

		window.addEventListener('resize', this.getHeaderHeight.bind(this));

		this.getHeaderHeight();
	}

	getHeaderHeight() {
		this.heightHeader = this.element.offsetHeight;
	}
}

document.querySelectorAll('.o-header').forEach((_) => new OHeader(_));
